/**
 * @generated SignedSource<<855d83dab38037b4c84a9c2eecba381d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type requestType_nativeIssueTable_RequestTypeCell$data = {
  readonly id?: string;
  readonly requestType: {
    readonly avatar: {
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "requestType_nativeIssueTable_RequestTypeCell";
};
export type requestType_nativeIssueTable_RequestTypeCell$key = {
  readonly " $data"?: requestType_nativeIssueTable_RequestTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestType_nativeIssueTable_RequestTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "requestType_nativeIssueTable_RequestTypeCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
};

(node as any).hash = "426fa73f24ee625613ad6e1ed09d9b53";

export default node;
